import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogDiscountCategoryDTOBase } from "./CatalogDiscountCategoryDTOBase";
import type { CatalogDiscountStaff } from "./CatalogDiscountStaff";
import type { TrackedBase } from "./TrackedBase";

export class CatalogDiscountCategoryStaff implements CatalogDiscountCategoryDTOBase, TrackedBase {
  constructor(public readonly categoryId: number, public readonly categoryName: string | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly discounts: Array<CatalogDiscountStaff> | null) {
    this.cbiServiceContext = null;
    this.discountsLoaded = this.discounts != null;
    this.discountsCached = this.discounts;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private discountsLoaded: boolean;
  private discountsCached: Array<CatalogDiscountStaff> | null;
  async discountsLazy(): Promise<Array<CatalogDiscountStaff>> {
    if (!this.discountsLoaded) {
      this.discountsCached = await this.cbiServiceContext!.discountService().getCatalogDiscountCategoryStaffDiscounts(this.categoryId);
      this.discountsLoaded = true;
    }
    return this.discountsCached!;
  }
}
